import {routes, request} from "./"

export function refreshOrders(commit, firstOrderId, showload = true) {
  return request(commit, routes.orders.refresh, { first_order_id: firstOrderId }, 'get', 'true', showload)
}

export function loadNewOrders(commit, lastOrderID) {
  return request(commit, routes.orders.loadNew, { last_order_id: lastOrderID })
}

export function loadOrders(commit, options) {
  return request(commit, routes.orders.load, options)
}

export function loadOrder(commit, order_id) {
  return request(commit, routes.orders.loadSingle, { order_id })
}

export function updateOrder(commit, order) {
  return request(commit, routes.orders.update, true, 'post')
}

export function deleteOrder(commit, order) {
  return request(commit, routes.orders.delete, false)
}

export function archiveOrder(commit, ordersArray) {
  return request(commit, routes.orders.archive, ordersArray, 'post')
}

export function unarchiveOrder(commit, ordersArray) {
  return request(commit, routes.orders.unarchive, ordersArray, 'post')
}

export function markOrderPrinted(commit, ordersArray) {
  return request(commit, routes.orders.print, ordersArray, 'post')
}

export function markOrderNotPrinted(commit, ordersArray) {
  return request(commit, routes.orders.unprint, ordersArray, 'post')
}

export function voidOrder(commit, ordersArray) {
  return request(commit, routes.orders.void, ordersArray, 'post')
}

export function unvoidOrder(commit, ordersArray) {
  return request(commit, routes.orders.unvoid, ordersArray, 'post')
}

export function updateAccountNumber(commit, { order_id, account_number }) {
  return request(commit, routes.orders.updateAccountNumber, { order_id, account_number }, 'post')
}




//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/orders.js
// module id = 608
// module chunks = 0